import { makeSelectors } from '@utils/css';

const iconTransitionDurationMs = 150;
const modifiers = makeSelectors({
  inversed: "dibi1wyf9mj",
  accent: "dibaczgcpo",
  black: "dibb1vbji2",
  large: "diblfwtj4g",
  small: "dibs140zm9h",
  defaultIcon: "dibd1cz8jmf"
});
const wrapper = "dibw1s1f6eu";
const iconWrapper = "dibiu1rpg";
const circularSelectors = makeSelectors({
  wrapper
});

export { modifiers as circularModifiers, circularSelectors, iconTransitionDurationMs, iconWrapper, modifiers, wrapper };
import "./circular.style.linaria.module.css";
//# sourceMappingURL=circular.style.js.map
